import { DaysOfWeekDisplay } from '../domains/tfDomain';
import moment from 'moment';
import { RFQ_SHIPPING_DATE_FORMAT_LOCAL } from 'components/RevxDate';

export const dateToWeek = (date: string) => {
  if (!date) return '';
  return Object.values(DaysOfWeekDisplay)[new Date(date).getDay()] || '';
};

export const formatLocalDate = (date: moment.Moment) =>
  date?.format(RFQ_SHIPPING_DATE_FORMAT_LOCAL);
